import { FormattedMessage } from 'react-intl';
import { useRecoilState, useRecoilValue } from 'recoil';
import ConfirmationDialog from '~/components/Dialogs/ConfirmationDialog';
import { DICOMApprovalStatus } from '~/domain/dicom/dicomstructureset';
import { openedStructureSetApprovalConfirmationDialogState } from '~/state/atoms/structureSet/roiAtoms';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';

const StructureSetApprovalStatusConfirmationDialog = ({
    onApprovalStatusChange,
}: {
    onApprovalStatusChange: (status: DICOMApprovalStatus) => void;
}) => {
    const currentStructureSet = useRecoilValue(currentStructureSetState);
    const [
        openedStructureSetApprovalConfirmationDialog,
        setOpenedStructureSetApprovalConfirmationDialog,
    ] = useRecoilState(openedStructureSetApprovalConfirmationDialogState);

    const handleStructureSetApprovalStatusChangeConfirmation = () => {
        if (openedStructureSetApprovalConfirmationDialog) {
            onApprovalStatusChange(
                openedStructureSetApprovalConfirmationDialog?.newApprovalStatus
            );
            setOpenedStructureSetApprovalConfirmationDialog(null);
        }
    };

    const handleStructureSetApprovalStatusChangeDialogCancel = () => {
        setOpenedStructureSetApprovalConfirmationDialog(null);
    };

    return (
        openedStructureSetApprovalConfirmationDialog && (
            <ConfirmationDialog
                open={
                    openedStructureSetApprovalConfirmationDialog.sopUid ===
                    currentStructureSet?.dicomStructureSet.sopInstanceUID
                }
                onCancel={handleStructureSetApprovalStatusChangeDialogCancel}
                onConfirm={handleStructureSetApprovalStatusChangeConfirmation}
                title={<FormattedMessage id="confirmApprovalStatusChange" />}
                message={
                    <FormattedMessage
                        id="structureSetApprovalStatusChangeDescription"
                        values={{
                            newApprovalStatus: (
                                <strong>
                                    {
                                        openedStructureSetApprovalConfirmationDialog.newApprovalStatus
                                    }
                                </strong>
                            ),
                        }}
                    />
                }
                cancelText={<FormattedMessage id="cancel" />}
                confirmText={<FormattedMessage id="confirm" />}
                mode={'secondary'}
            />
        )
    );
};

export default StructureSetApprovalStatusConfirmationDialog;
